import { inject } from 'mobx-react';
import { MenuV1Component } from './component';
export const MenuV1 = inject(({ ui, router, auth }) => ({
    mainMenu: ui.menu,
    iconUrl: ui.iconUrl,
    uiVersion: ui.uiVersion,
    envLabel: ui.environmentLabel,
    currentPath: router.currentPath,
    hidden: ui.hideMenu || ui.uiVersion === 'V2',
    navigate: router.navigate,
    logout: auth.logout,
}))(MenuV1Component);
//# sourceMappingURL=index.js.map